import { RootState } from '../../app/store/store';

export function selectVirazhData(state: RootState) {
  return state.virazh.data;
}
